import { Placeholder, Title, Intro, ChartStandIcon } from './styled';

import loadable from '@loadable/component';

import Break from '@/components/Break';

const Search = loadable(
  () => import('@/pages/Watchlist/components/Empty/Search')
);

const FeedPlaceholder = () => {
  return (
    <Placeholder>
      <ChartStandIcon />
      <Title>Watch stocks and stay informed</Title>
      <Intro>
        Add companies to your portfolio to{` `}
        <Break xsDown />
        track important updates
      </Intro>
      <Search />
    </Placeholder>
  );
};

export default FeedPlaceholder;
